import { headers as defaultHeaders } from '@/config/axios';
import axiosRequest from '.';

const create = async (data) => (
  axiosRequest({
    url: '/v1/paymentProof/create',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

const getAll = async (data) => (
  axiosRequest({
    url: '/v1/paymentProof/getAll',
    method: 'post',
    headers: defaultHeaders,
    data,
  })
);

const getOneById = async (data) => (
  axiosRequest({
    url: '/v1/paymentProof/getOne',
    method: 'post',
    data,
    headers: defaultHeaders,
  })
);

const update = async (data) => (
  axiosRequest({
    url: '/v1/paymentProof/update',
    method: 'post',
    data,
    headers: defaultHeaders,
  })
);

export {
  create,
  getAll,
  getOneById,
  update,
};
